import { FC } from 'react';
import { Flex, Text } from '@chakra-ui/layout';
import { VscError } from 'react-icons/vsc';

const WebglUnavailable: FC = () => {
  return (
    <Flex flexDir='column' alignItems='center' py={6}>
      <VscError fontSize='32px' />
      <Text mt={2}>
        <strong>Cannot load Crucible artwork.</strong>
      </Text>
      <Text mt={2}>
        Your browser does not have WebGL enabled. Please check your settings and
        try again.
      </Text>
    </Flex>
  );
};

export default WebglUnavailable;
